import { RowExportTypePdf } from "types";
import { PdfTemplate } from "components";
import { DataList } from "../types";

export function PdfMagister(props: { dataList: DataList[] }) {
  const columns = [
    { header: "NO", key: "no", width: 5 },
    { header: "CODE", key: "code", width: 10 },
    { header: "S2", key: "s2", width: 10 },
    { header: "DESCRIPTION", key: "description", width: 15 },
  ];

  const dataMap: RowExportTypePdf[] = props.dataList.map((item, index) => ({
    no: index + 1,
    code: item.magister_code ?? "-",
    s2: item.magister_name ?? "-",
    description: item.description ?? "-",
  }));

  return <PdfTemplate data={dataMap} column={columns} title="S2" />;
}
